import { render, staticRenderFns } from "./coinRecord.vue?vue&type=template&id=ab550ed8&scoped=true&"
import script from "./coinRecord.vue?vue&type=script&lang=js&"
export * from "./coinRecord.vue?vue&type=script&lang=js&"
import style0 from "./coinRecord.vue?vue&type=style&index=0&id=ab550ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab550ed8",
  null
  
)

export default component.exports